import { React } from "react";
import { Input, ErrorMessage, SubmitButton, Select } from "components/Forms";
import "./style.css";
import getMachineToolTypes from "services/getMachineToolTypes";
import useAPI from "effects/useAPI";
import postMachine from "services/postMachine";
import * as yup from "yup";
import { Form } from "components/Forms";
import notify from "utils/toastMsg";

const schema = yup.object().shape({
  machineName: yup
    .string()
    .required()
    .max(17, "Machine Name must be at most 17 characters.")
    .label("Machine Tool Name")
    .typeError("The Machine Name must be at most 17 characters."),
  machineModel: yup
    .string()
    .required()
    .max(17, "Machine Tool Name must be at most 17 characters.")
    .label("Machine Model")
    .typeError("The Machine Model must be at most 17 characters."),
  machineToolTypeId: yup
    .string()
    .required()
    .label("Machine Tool Type")
    .typeError("The Machine Tool Type is required."),
});

function AddNewMachine({ handleClose, fetchAllMachines }) {
  const [
    machineToolTypesLoading,
    machineToolTypesError,
    machineToolTypesResponse,
  ] = useAPI(() => getMachineToolTypes());

  const handleMachineToolSubmit = async (values, event, methods) => {
    // const { machineName } = values;
    // const doesMachineToolExists = () => {
    //   const checkIfExists = machineTools.some((machine, index) => {
    //     return machine.machineName === machineName;
    //   });
    //   return checkIfExists;
    // };
    // if (doesMachineToolExists()) {
    //   notify("Machine name must be unique. ❌ ");
    //   return;
    // }
    try {
      await postMachine({
        ...values,
      });
      notify("Machine Tool created successfully. ✅ ");
      fetchAllMachines();
      handleClose();
    } catch (err) {
      throw err;
    }
  };

  // loading
  if (machineToolTypesLoading) {
    return <div>Loading...</div>;
  }

  // error
  if (machineToolTypesError) {
    return <div>Oops! Something went wrong. Please try again.</div>;
  }

  const { machineToolTypes } = machineToolTypesResponse;

  const machineToolTypesOptions = [];

  machineToolTypes.map((type) =>
    machineToolTypesOptions.push({
      key: type.machineToolTypeId,
      value: type.machineToolTypeId,
      label: type.machineToolTypeName,
    })
  );

  return (
    <div
      className="d-flex justify-content-center align-items-center modal-container-add-new-machine "
      onClick={() => handleClose()}
    >
      <div
        className="main-container-pop-add-new-machine "
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="pop-up-content-add-new-machine">
          <div className="d-flex justify-content-end align-items-end">
            <i
              onClick={() => handleClose()}
              type="button"
              className="mdi mdi-close fs-xl"
            ></i>
          </div>
          <h2 className="d-flex justify-content-center title-add-new-machine">
            Add New Machine
          </h2>
          <div className="d-flex justify-content-center flex-column">
            <Form
              initialValues={{
                machineName: "",
                machineModel: "",
                machineToolTypeId: "1",
              }}
              validationSchema={schema}
              onSubmit={handleMachineToolSubmit}
            >
              <div className="d-flex flex-row justify-content-center align-items-center input-wrapper-add-new-machine">
                <div className="d-flex flex-column justify-content-center align-items-center input-wrapper-add-new-machine">
                  <h4>Machine Name</h4>
                  <Input
                    name="machineName"
                    type="text"
                    className="form-control"
                    placeholder="Machine Name"
                  />
                  <ErrorMessage name="machineName" />
                  <h4>Machine Model</h4>
                  <Input
                    name="machineModel"
                    type="text"
                    className="form-control"
                    placeholder="Machine Model"
                  />
                  <ErrorMessage name="machineModel" />
                </div>
              </div>
              <div className="d-flex mb-4 flex-column justify-content-center align-items-center input-wrapper-add-new-machine">
                <h4>Machine Type</h4>
                <Select
                  name="machineToolTypeId"
                  type="text"
                  className="form-control form-control-size-add-new-machine"
                  placeholder="Select Machine Tool Type"
                  options={machineToolTypesOptions}
                />
                <ErrorMessage name="machineToolTypeId" />
              </div>
              <div className="d-flex mt-3 justify-content-center">
                <SubmitButton
                  className="create-btn-add-new-machine btn-success waves-effect"
                  type="submit"
                >
                  Create
                </SubmitButton>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewMachine;
